// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import { DateTime } from 'luxon';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

// import actions
import * as nodeActions from '../../node/nodeActions';
import * as userModuleActions from '../../userModule/userModuleActions';
import * as userNodeActions from '../../userNode/userNodeActions';
import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';

// import utilities
import certUtils from '../../../global/utils/certUtils';
import progressUtils from '../../../global/utils/progressUtils';
import videoUtils from '../../../global/utils/videoUtils';
// not updating links here because this should no longer be used with london handling agenda

class ContentModuleCard extends Base {

  constructor(props) {
    super(props);
    this.state = {
      startOverAlertOpen: false
      , trailerModalOpen: false
    }
  }

  componentDidMount() {
    const { dispatch, contentModule, loggedInUser } = this.props;
    // moving these out to MyAgened so this component isnt logging so much 
    // TODO: make sure these are fetched other places ContentModuleCard is used besides MyAgenda
    // dispatch(moduleCertificateActions.fetchListIfNeeded('_user', loggedInUser._id, '_contentModule', contentModule._id))
    if(!loggedInUser.admin) {
      dispatch(nodeActions.fetchListIfNeeded('_contentModule',contentModule._id, 'checkpoint', true ));
      dispatch(userNodeActions.fetchListIfNeeded('_user', loggedInUser._id, '_contentModule', contentModule._id));
    }
  }

  render() {
    const {
      loggedInUser
      , match
      , moduleCertificateStore
      , nodeStore
      , sponsor
      , contentModule
      , userModuleStore
      , userNodeStore
    } = this.props;
    const { startOverAlertOpen, trailerModalOpen } = this.state;
    const userModuleList = userModuleStore.util.getList('_user', loggedInUser._id).filter(um => um._contentModule == contentModule._id) || [];
    const moduleCertificateList = moduleCertificateStore.util.getList('_user', loggedInUser._id).filter(cert => cert._contentModule == contentModule._id) || [];
    const noCerts = (
      !moduleCertificateList
      || moduleCertificateList.length < 1
    )

    let latestCert;
    if(!noCerts) {
      // if ANY valid cert, use it. else display most recently updated.
      // 1.14 - no longer true. if completed, use it. else if pending, use that. else use ANY valid cert.
      latestCert = certUtils.findCompletedCert(moduleCertificateList)
      if(!latestCert) {
        latestCert = certUtils.getLatestCert(moduleCertificateList);
      } else if(latestCert.status == "expiring-soon") {
        // need additional check to determine if we have a "pending" certificate to show instead
        if(moduleCertificateList.filter(cert => cert.status == 'pending-attestation').length > 0) {
          latestCert = moduleCertificateList.filter(cert => cert.status == 'pending-attestation')[0]
        }
      }
    }

    const hasValidCert = certUtils.checkIfValid(latestCert, contentModule);
    
    const sortedUserModules = userModuleList.sort((a,b) => new Date(b.updated) - new Date(a.updated)); // make sure we use only the most recent UserModule
    // console.log("sortedUserModules", sortedUserModules)
    const userModule = sortedUserModules.length > 0 ? sortedUserModules[0] : null;

    const checkpointNodes = nodeStore.util.getList("_contentModule", contentModule._id, "checkpoint", true);
    const previouslyViewedNodes = userNodeStore.util.getList('_user', loggedInUser._id).filter(un => un._contentModule == contentModule._id) || [];
    const progressCount = progressUtils.getProgressCount(checkpointNodes, previouslyViewedNodes);
    const progressPercent = progressUtils.getProgressPercent(checkpointNodes, previouslyViewedNodes, hasValidCert);
    // NOTE: give the yt-col an id so we can # link to it from 'New CM' emails
    let progressClass = classNames(
      `progress-bar-${progressPercent}`
    )
    const cardClass = classNames(
      "card tm-card -bordered"
      , { '-show-path': this.props.showPath }
    )
    // console.log("TEST!", contentModule.testable, contentModule._id)

    // we need this field to determine whether to display a "restart" button or a "continue" button if a user has an expired cert
    let userModuleTiedToLatestCert = false;
    if(userModule) {
      if(latestCert && latestCert._userModule == "" + userModule._id) {
        userModuleTiedToLatestCert = true;
      }
      // console.log(latestCert);
      // console.log("USER MODULE", userModuleTiedToLatestCert);
      // console.log(userModule);
    }

    let logoUrl = contentModule.brandingLogoUrl ? contentModule.brandingLogoUrl : (sponsor && sponsor.logo) ? sponsor.logo : "/img/cert-icons/cert-icon-empty@2x.png"; 

    // let linkUrl = match.url; 
    let linkUrl = `/my-agenda`

    return (
      <div className="tm-card-wrapper">
      {/* Move all ReactTooltips to the root div of this component so that the stacking context allows the tooltip to display on top of everything else. */}
        <ReactTooltip
          aria-haspopup='true'
          className="yt-tooltip"
          id={`tm-progress_${contentModule._id}`}
          place="top"
          type="dark"
        >
          <p>{progressCount.true ? progressCount.true : 0} of {!checkpointNodes ? 0 : checkpointNodes.length} checkpoints reached</p>
        </ReactTooltip>
        <ReactTooltip
          aria-haspopup='true'
          id={`trailer-${contentModule._id}`}
          place="top"
          type="dark"
        >
          <p>Play simulation trailer</p>
        </ReactTooltip>
        <ReactTooltip
          aria-haspopup='true'
          id={`certificate-${contentModule._id}`}
          place="top"
          type="dark"
        >
          <p>View & print certificate</p>
        </ReactTooltip>
        <div id={`tm_${contentModule._id}`} className={cardClass}>
          <div>
            <div className="-cert">
              { hasValidCert 
              ?
                <div>
                  <img className="u-pullLeft" alt="certificate achieved" src={logoUrl}/>
                  <div className="tm-icon-wrapper u-pullRight" style={{margin: "10px"}}>
                    <i className="fal fa-badge-check fa-2x" style={{color: "#00BC8B"}} />
                  </div>
                </div>
              :
                <img alt="certificate achieved" src={logoUrl}/>
              }
            </div>
          </div>
          <div className="tm-card">
            <div className="title"> {contentModule.title} </div>
            {contentModule.version ? 
              <p className="-summary"> Version {contentModule.version} </p>
            : null
            }
            {contentModule.trailerVidPath ? 
              <div className="trailer-link" onClick={() => this.props.openVideoPlayer(contentModule)}>View Trailer
                <i className="fal fa-play-circle fa" />
              </div>
            : 
              <div className="trailer-link"/>
            }
            <div className="node-progress-wrapper">
              <div className={progressClass} data-tip data-for={`tm-progress_${contentModule._id}`}>
                <div className="-progress">
                  <div className="-complete">
                    {userModule && userModule.status == "completed" ?
                      <img src="/img/progress-checkmark.png"/>
                      :
                      <img src="/img/progress-circle.png"/>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="yt-row center-vert space-between">
              { latestCert && latestCert.status == "pending-attestation" ?
              // 0. REQUIRES ATTESTATION BEFORE COMPLETE
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">VERIFICATION REQUIRED</div>
                  <Link className="yt-btn small rounded warning" to={`/my-certificates/${latestCert._id}`}>FINISH</Link>
                </div>
              : latestCert && !hasValidCert && userModuleTiedToLatestCert ?
                // 1. EXPIRED OR INVALID CERT, MUST RESTART
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRED!</div>
                  <button className="yt-btn small rounded " onClick={() => this.props.openStartOverModal(contentModule)}>Restart Training</button>
                </div>
              : latestCert && !hasValidCert ?
                // 2. EXPIRED OR INVALID CERT, ALREADY RESTARTED THOUGH
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRED!</div>
                  <Link className="yt-btn small rounded " to={userModule && userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>Continue Training</Link>
                </div>
              : latestCert && latestCert.status == "expiring-soon" && userModuleTiedToLatestCert ?
                // 3. VALID CERT BUT EXPIRING SOON, MUST RESTART
                  <div className="yt-col full" style={{marginBottom: "8px"}}>
                    <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRING SOON!</div>
                    <button className="yt-btn small rounded " onClick={() => this.props.openStartOverModal(contentModule)}>Restart Training</button>                  
                  </div>
              : latestCert && latestCert.status == "expiring-soon" ?
                // 4. VALID CERT BUT EXPIRING SOON, ALREADY RESTARTED
                  <div className="yt-col full" style={{marginBottom: "8px"}}>
                    <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRING SOON!</div>
                    <Link className="yt-btn small rounded " to={userModule && userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>Continue Training</Link>
                  </div>
              : latestCert ?
                // 5. VALID CERT
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <Link className="yt-btn small rounded dark" to={`/my-agenda/cms/${contentModule.slug}/conclusion`}>Print Certificate</Link>
                </div>
              : 
              userModule && userModule._lastNode ?
                // 6. NO CERTS BUT ALREADY STARTED MODULE
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <Link className="yt-btn small rounded " to={`${linkUrl}/cms/${contentModule.slug}/node/${userModule._lastNode}`}>Resume</Link>
                </div>
              : 
                // 7. NO CERTS AT ALL, BEGIN
                <div className="yt-col _50" style={{marginBottom: "8px"}}>
                  <Link className="yt-btn small rounded bordered  " to={`${linkUrl}/cms/${contentModule.slug}`}>Begin</Link>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ContentModuleCard.propTypes = {
  dispatch: PropTypes.func.isRequired
  , showPath: PropTypes.bool
  , contentModule: PropTypes.object.isRequired
}

ContentModuleCard.defaultProps = {
  showPath: true
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , moduleCertificateStore: store.moduleCertificate
    , nodeStore: store.node
    , userModuleStore: store.userModule
    , userNodeStore: store.userNode
  }
}

export default withRouter(connect(mapStoreToProps)(ContentModuleCard));



// WEBPACK FOOTER //
// modules/contentModule/components/ContentModuleCard.js.jsx